import { useState } from "react";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { AppDialog } from "../../components/AppDialog";
import { AppDialogHeader } from "../../components/AppDialogHeader";
import { createAlbum } from "../../../albumsApi";

export function CreateAlbumDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  function handleClose() {
    setName("");
    setDescription("");
    setError("");
    onClose();
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");

    const trimmedName = name.trim();
    if (!trimmedName) {
      setError("Album name is required.");
      return;
    }

    setSaving(true);
    const result = await createAlbum(trimmedName, description.trim());
    setSaving(false);

    if (!result.ok) {
      setError(result.error);
      return;
    }
    handleClose();
  }

  return (
    <AppDialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <AppDialogHeader icon="bi-folder-plus" title="Create New Album" onBack={handleClose} disabled={saving} />
      <DialogContent sx={{ p: 4, pt: 2 }}>
        <Box component="form" onSubmit={handleSubmit} sx={{ display: "grid", gap: 2 }}>
          <TextField
            label="Album Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g., Summer Vacation 2024"
            required
            fullWidth
            size="small"
            slotProps={{ htmlInput: { maxLength: 100 } }}
          />
          <TextField
            label="Description (optional)"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Add a description..."
            multiline
            rows={2}
            fullWidth
            size="small"
            slotProps={{ htmlInput: { maxLength: 500 } }}
          />
          {error && (
            <Alert severity="error" sx={{ py: 0.5 }}>
              {error}
            </Alert>
          )}
          <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
            <Button variant="outlined" color="primary" onClick={handleClose}>
              Cancel
            </Button>
            <Button type="submit" variant="contained" color="primary" disabled={saving}>
              <i className="bi bi-check-lg me-1" aria-hidden="true" style={{ marginRight: 6 }} />
              Create Album
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </AppDialog>
  );
}
